import React from "react";
import { bool, func } from "prop-types";
import Container from "./styled";
import disableScroll from "disable-scroll";
import { HiMenuAlt2 } from "react-icons/hi";

// Prop Types
Burger.propTypes = {
  open: bool.isRequired,
  setOpen: func.isRequired,
};

export default function Burger({ open, setOpen }) {
  const toggleOpen = () => {
    setOpen(!open);
    disableScroll.on();
  };

  return (
    <Container open={open} onClick={toggleOpen}>
      {/* Botón Abrir */}
      <button onClick={toggleOpen}>
        <HiMenuAlt2></HiMenuAlt2>
      </button>
    </Container>
  );
}
